import { useState, useEffect } from "react";
import {API_SERVER} from './environments/environments.js'

export const url = `${API_SERVER}form-resiter-landingpate`;

export const options = (data) => {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
};

export default function useDevice() {
  const [device, setDevice] = useState("desktop");
  function handleResize() {
    const width = window.innerWidth;
    if (width < 640) {
      setDevice("mobile");
      return;
    }
    if (width < 1024) {
      setDevice("tablet");
      return;
    }
    setDevice("desktop");
  }
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return device;
}
